import { render, staticRenderFns } from "./accessoriesList.vue?vue&type=template&id=5ed26cfb&scoped=true"
import script from "./accessoriesList.vue?vue&type=script&lang=js"
export * from "./accessoriesList.vue?vue&type=script&lang=js"
import style0 from "./accessoriesList.vue?vue&type=style&index=0&id=5ed26cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed26cfb",
  null
  
)

export default component.exports